import defaultTheme from './default'
import horizontalTheme from './horizontal'
declare module '@material-ui/core/styles/createMuiTheme' {
  interface ThemeOptions {
    one_login_width?: number
    live_gradient_color?: string
    content_box_width?: number
  }

  interface Theme {
    one_login_width: number
    live_gradient_color: string
    content_box_width: number
  }
}

const themes = {
  horizontalTheme,
  defaultTheme,
}

export default themes
